import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Authmiddleware from "routes/AuthMiddleWare";
import GlobalContext from "context/GlobalContext";
import { validateSession } from "Helper/SessionValidator";

const App = () => {
  const [isValidating, setIsValidating] = useState(true);

  // Validate session on mount for cross-subdomain SSO support
  useEffect(() => {
    const checkSession = async () => {
      // Only validate if no local token exists
      if (!localStorage.getItem("token")) {
        await validateSession();
      }
      setIsValidating(false);
    };
    checkSession();
  }, []);

  // Show loading during session validation
  if (isValidating) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa"
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <GlobalContext>
      <BrowserRouter>
        {/* Suspense boundary for lazy-loaded components */}
        <Suspense fallback={<div>{null}</div>}>
          <Authmiddleware />
        </Suspense>
      </BrowserRouter>
    </GlobalContext>
  );
};

export default App;
